import { adminOrders, orderLine } from "../parts";
import { date, dateTime, figures, h, link, money, show, statusChip, table, td, th, userLink } from "../ui";

export async function orderPage() {
  const id = new URLSearchParams(location.search).get("id") ?? "";
  const ord = await adminOrders({ q: id, limit: 5 });
  if (!ord) return;
  const o = ord.orders.find((x) => x.id === id);
  if (!o) return show("Order", "No such order.", link("/orders", "← All orders"));
  show(
    `Order ${o.id}`,
    `${o.username || o.email || o.account_id} · ${orderLine(o)} · created ${dateTime(o.created_at)}`,
    h("p", null, link("/orders", "← All orders"), " · ", userLink(o.account_id, "User")),
    figures([
      ["Total", o.status === "manual" ? "granted" : money(o.amount / 100), o.status === "manual" ? "by staff, no payment" : o.currency.toUpperCase()],
      ["Status", o.status, o.refunded_amount ? `${money(o.refunded_amount / 100)} refunded` : ""],
      ["Paid", o.paid_at ? dateTime(o.paid_at) : "—"],
      ["Term", o.ends_at ? `${date(o.starts_at ?? o.created_at)} – ${date(o.ends_at)}` : "—"],
    ]),
    h("h2", null, "Payment"),
    table(
      [th("Field"), th("Value")],
      [
        h("tr", null, td("Status"), h("td", null, statusChip(o.status))),
        h("tr", null, td("Luwu Pay payment"), td(o.payment_id ?? (o.status === "manual" ? "none (granted by staff; the log says who and why)" : "—"), "mono")),
        h("tr", null, td("Plan"), td(orderLine(o))),
        h("tr", null, td("Buyer"), td(`${o.username ?? ""} ${o.email ?? ""} ${o.account_id}`.trim())),
      ],
      "",
    ),
    o.status === "manual" ? h("p", null, link(`/logs?kind=admin.grant&q=${encodeURIComponent(o.id)}`, "The grant in the log →")) : null,
  );
}
